import React, { useState, useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { addUsers } from "../../store/actions/userAction";
import styles from "./render-checkbox.module.css";
import {
	checkedCheckboxIcon,
	uncheckedCheckboxIcon,
} from "./checkbox-icons";

export default function RenderCheckBox(props) {
	const { item, setSelectedPlayers } = props;
	const [checked, setChecked] = useState(false);
	const dispatch = useDispatch();
	const accessUser = useSelector((state) => state.user);

	useEffect(() => {
		const found = accessUser?.data?.find(
			(m) => m.member_id === item.member_id,
		);

		setChecked(!!found);
	}, [accessUser?.data, item]);

	const handleChange = (e) => {
		setChecked(e.target.checked);

		if (e.target.checked) {
			const newData = accessUser?.data
				? [...accessUser.data, { ...item }]
				: [{ ...item }];
			dispatch(addUsers(newData));
			if (typeof setSelectedPlayers === "function")
				setSelectedPlayers(newData);
		} else {
			const newData = accessUser?.data.filter(
				(itm) => itm.member_id !== item.member_id,
			);
			dispatch(addUsers([...newData]));
			if (typeof setSelectedPlayers === "function")
				setSelectedPlayers(newData);
		}
	};

	return (
		<Checkbox
			color="default"
			className={styles.root}
			checked={checked}
			icon={uncheckedCheckboxIcon}
			checkedIcon={checkedCheckboxIcon}
			style={{
				transform: "scale(0.85)",
			}}
			onChange={handleChange}
		/>
	);
}
